import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export function usePreventNavigation() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const confirmationMessage =
        "¿Seguro que querés salir de la actividad? Si salís ahora, vas a perder todo tu progreso."
      e.preventDefault()
      // Using returnValue even though it's deprecated as it's still required for cross-browser compatibility
      e.returnValue = confirmationMessage
      return confirmationMessage
    }

    const handlePopState = (e: PopStateEvent) => {
      if (
        window.confirm(
          "¿Seguro que querés salir de la actividad? Si salís ahora, vas a perder todo tu progreso.",
        )
      ) {
        navigate("/study")
      } else {
        window.history.pushState(null, "", window.location.pathname)
        e.preventDefault()
      }
    }

    // Add a state to the history to make sure we can catch the back button
    window.history.pushState(null, "", window.location.pathname)

    window.addEventListener("beforeunload", handleBeforeUnload)
    window.addEventListener("popstate", handlePopState)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
      window.removeEventListener("popstate", handlePopState)
    }
  }, [navigate])
}
